@if (this.useContainer()) {
    <div class="p-3 d-block bg-primary bg-opacity-10 rounded d-flex align-items-center">
        <div class="cursor" role="button" (click)="openModal()">
            <span class="fw-bold">{{ tooltip() }}</span>
        </div>
        <button
            type="button"
            class="ms-auto ai-generator-btn"
            [class.ai-generator-btn-sm]="size() === 'sm'"
            [class.ai-generator-btn-lg]="size() === 'lg'"
            [class.ai-generator-btn-compact]="compact()"
            [ngbTooltip]="tooltip()"
            (click)="openModal()">
            <div class="waves">
                <div class="wave wave1"></div>
                <div class="wave wave2"></div>
                <div class="wave wave3"></div>
            </div>
            <div class="btn-content">
                <fa-icon size="xs" [icon]="['fas', icon()]" class="icon"></fa-icon>
            </div>
        </button>
    </div>
} @else {
    <button
        type="button"
        class="ms-auto ai-generator-btn"
        [class.ai-generator-btn-sm]="size() === 'sm'"
        [class.ai-generator-btn-lg]="size() === 'lg'"
        [class.ai-generator-btn-compact]="compact()"
        [ngbTooltip]="tooltip()"
        (click)="openModal()">
        <div class="waves">
            <div class="wave wave1"></div>
            <div class="wave wave2"></div>
            <div class="wave wave3"></div>
        </div>
        <div class="btn-content">
            <fa-icon size="xs" [icon]="['fas', icon()]" class="icon"></fa-icon>
        </div>
    </button>
}
